import assign from "lodash/fp/assign";
import startCase from "lodash/fp/startCase";
import map from "lodash/fp/map";
import moment from "moment";
import isNil from "lodash/fp/isNil";
import constants from "../../core/constants";

class RideBackupsTransform {
  constructor() {
    "ngInject";

    this.selectedBackup = "";
    this.setSelectedBackup = (id) => {
      this.selectedBackup = id;
    };

    // NOTE: name is used for (user roles)
    this.item = {
      title: "Backup",
      state: "backup",
      name: "backup",
    };

    this.fields = [
      {
        title: "Selected",
        select: true,
        onSelect: ({ _id }) => this.setSelectedBackup(_id),
        action: true,
      },
      {
        title: "Captain Name",
        name: "captain",
        linksTo: "captain",
        idKeyName: "_id",
        linkTarget: "_blank",
      },
      {
        title: "Status",
        name: "status",
        tagColorKeys: {
          scheduled: "plain",
          started: "primary",
          stopped: "secondary",
          busy: "danger",
        },
      },
      { title: "Phone Number", name: "phone" },
      { title: "Shift Start Time", name: "start_date" },
      { title: "Shift End Time", name: "end_date" },
      { title: "Last location time", name: "last_location_timestamp" },
      { title: "Distance", name: "distance" },
      { title: "Category", name: "category_name" },
      { title: "Vehicle Type", name: "bus_type" },
      {
        title: "Backup Station",
        name: "backup_station",
        linksTo: "station",
        idKeyName: "_id",
        linkTarget: "_blank",
      },
      { title: "District", name: "district" },
      { title: "Free At", name: "free_at" },
    ];

    this.filters = [
      {
        name: "captain",
        title: "Captains",
        icon: "person_outline",
        resource: "Captain",
        size: 25,
        hasExact: true,
        exactFields: ["name", "phone"],
      },
      {
        name: "status",
        title: "Status",
        icon: "people_outline",
        list: "backupStatus",
        size: 25,
        multiple: true,
      },
      {
        name: "start_time",
        title: "Shift start time",
        icon: "date_range",
        size: 25,
        isDateTime: true,
      },
      {
        name: "end_time",
        title: "Shift end time",
        icon: "date_range",
        size: 25,
        isDateTime: true,
      },
      {
        name: "bus_type",
        title: "Bus type",
        icon: "directions_bus",
        resource: "Bustype",
      },
      {
        name: "backup_station",
        title: "Backup station",
        icon: "add_location_alt",
        resource: "Station",
        resourceParams: { backup: true },
      },
      {
        name: "ride_type",
        title: "Ride category",
        icon: "directions_car",
        list: "rideCategoryList",
        multiple: true,
      },
    ];
  }

  justify(data) {
    const format = (item) => {
      item = assign({ _id: item._id }, item._source);
      item.phone = item.captain ? item.captain.phone : "";
      item.backup_station = {
        name: item.backup_station ? item.backup_station.name_i18n.en : "",
        _id: item.backup_station ? item.backup_station._id : "",
      };
      item.district = {
        name: item.district ? item.district.name_i18n.en : "",
        _id: item.district ? item.district._id : "",
      };
      item.distance = !isNil(item.distance)
        ? `${item.distance === 0 ? 0 : (item.distance / 1000).toFixed(2)} KM`
        : "";
      item.category_name = item.ride_category
        ? `${startCase(item.ride_category.ride_type)} ${startCase(
            item.ride_category.service_type
          )}`
        : "";
      item.start_date = moment(item.start_date).format(
        constants.dateTimeFormat
      );
      item.last_location_timestamp = item.last_location_timestamp
        ? moment(item.last_location_timestamp).format(constants.dateTimeFormat)
        : "";
      item.end_date = moment(item.end_date).format(constants.dateTimeFormat);
      if (new Date(item.free_at).getTime()) {
        item.free_at = moment(item.free_at).format(constants.timeFormat);
      }

      return item;
    };

    return map(format)(data);
  }
}

export default RideBackupsTransform;



// WEBPACK FOOTER //
// ./src/pages/ride/rideBackups.transforms.js